/*
* 组件数组 视图内容输出
* */

'use strict';
var React = require('react');
var compHelper = require('../Components/compHelper');
var LazyLoad = require('../common/LazyLoad');
var styleHelper = require('../../helper/styleHelper');

var Components = React.createClass({
  propTypes: {
    events: React.PropTypes.object,
    components: React.PropTypes.array.isRequired,
    onLoad: React.PropTypes.func
  },
  componentWillMount: function () {
    this.loadingCount = this.props.components.length;
  },
  render: function () {
    var events = this.props.events;
    return (
      <div className='components'>
        {this.props.components.map(function (comp) {
          var order = styleHelper.getOrder(comp);
          return (
            <LazyLoad key={comp.controlID}
                      onLoad={this.onLoadComponent}
                      order={order}
            >
              {compHelper.makeComp(comp, events)}
            </LazyLoad>
          );
        }, this)}
      </div>
    );
  },
  onLoadComponent: function () {
    this.loadingCount --;
    if (this.loadingCount === 0 && this.props.onLoad) {
      this.props.onLoad();
    }
  }
});

module.exports = Components;



// WEBPACK FOOTER //
// ./src/views/Page/Components.jsx